import axios from "axios";
import { storage } from "../helpers/storage";

// Base Url for backend
export const BASEURL = process.env.REACT_APP_BASE_URL;

// Base Url with /api
export const API_URL = BASEURL + "/api";

// Initialize the axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
  },
});

// Api request interceptor initialization for inserting Auth token in the request headers
api.interceptors.request.use(
  async (config) => {
    // Auth token initialized from localstorage if exists
    let authToken = await storage.get("authToken");
    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Api response interceptor for logging out the user when the request is Unauthenticated
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message === "Unauthenticated."
    ) {
      storage.removeAll();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default api;
